<span class="star" [class.active]="active" (click)="handleRate()">&#9733;</span>